import {useState} from 'react';

export function useCommonStateLogic() {
    const [triedToSubmit, setTriedToSubmit] = useState<boolean>(false);

    return {triedToSubmit, setTriedToSubmit};
}
